export default __webpack_public_path__ + "static/media/tech-augmented-workforce.59f0fb26.svg";